import { join } from 'rise-ui/utils/string.js';
import { parseQueryParams, mergeParsedQueryParams, stringifyParsedQueryParams } from 'rise-ui/utils/url.js';

export function buildUrl(url, options = {}) {
  let { queryParams } = options;
  if (Array.isArray(url)) {
    url = join(url, '/');
  }
  let [ remoteUrl, fragment ] = url.split('#', 2);
  let [ endpoint, query ] = remoteUrl.split('?', 2);
  if (queryParams) {
    queryParams = parseQueryParams(queryParams);
    query = stringifyParsedQueryParams(
      mergeParsedQueryParams(parseQueryParams(query), queryParams)
    );
  }
  query = query ? '?' + query : '';
  fragment = fragment ? '#' + fragment : '';
  return `${endpoint}${query}${fragment}`;
}

export async function ajaxRequest(method, url, options = {}) {
  let {
    headers = {}, accept, contentType,
    body, form,
    parseResponse,
    jsonParse = !parseResponse,
  } = options;
  url = buildUrl(url, options);
  if (form) {
    if (form instanceof FormData) {
      body = form;
    } else {
      body = new URLSearchParams();
      (Array.isArray(form) ? form : Object.entries(form))
        .forEach(([ key, value ]) => body.append(key, value));
    }
  }
  const bodyType = typeof body;
  let response = await fetch(url, {
    method,
    headers: {
      ...headers,
      // GET requests without a body should not have a content-type header
      ...(!body && body !== 0 ? {} : {
        'Content-Type': contentType || (form ? 'application/x-www-form-urlencoded' : 'application/json'),
      }),
      Accept: accept || 'application/vnd.api+json, application/json, text/javascript, */*', // RISE default
    },
    body: bodyType === 'number' ? String(body) : !body ? undefined
      : body instanceof ArrayBuffer || body instanceof Int8Array
        || body instanceof Uint8Array || body instanceof Uint8ClampedArray
        || body instanceof Int16Array || body instanceof Uint16Array
        || body instanceof Int32Array || body instanceof Uint32Array
        || body instanceof Float32Array || body instanceof Float64Array
        || body instanceof DataView || bodyType === 'string'
        || [ 'Blob', 'File', 'URLSearchParams', 'FormData' ].includes(body?.constructor?.name)
          ? body
      : JSON.stringify(body),
  });
  if (parseResponse) {
    response = parseResponse(response);
  } else if (jsonParse) {
    response = await response.json();
  }
  return response;
}

export const verbs = [ 'get', 'head', 'post', 'put', 'delete', 'patch' ];

export function attachVerbs(obj, defaultOptions = {}) {
  return verbs.reduce((o, v) => {
      o[v] = (url, options) =>
        ajaxRequest(v, url, { ...defaultOptions, ...options });
      return o;
    }, obj);
}

export function ajax(defaultOptions = {}) {
  return attachVerbs({}, defaultOptions);
}
attachVerbs(ajax);

/**
 * Promise middleware to convert success to failure if status is fail
 * @param {*} response
 * @return {Promise<*>}
 */
export function okError(response) {
  return new Promise((resolve, reject) => {
    if (response && response.status === 'fail') {
      reject(response);
    } else {
      resolve(response);
    }
  });
}
